import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  InputNumber,
  message,
  Spin,
  Card,
  Space,
  Divider,
  Row,
  Col,
  Switch,
  Select,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";
import TinyEditor from "../../components/Editor";

const { TextArea } = Input;

const EditCountry = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingBrand, setLoadingBrand] = useState(false);
  const [uploading, setUploading] = useState(false);
  const editorRef = useRef(null);
  const [existingBanner, setExistingBanner] = useState(null);

  useEffect(() => {
    const fetchBrand = async () => {
      setLoadingBrand(true);
      try {
        const response = await api.get(`/panel/country/${id}`);
        const data = response?.data?.data;
        form.setFieldsValue({
          name: data?.name,
          slug: data?.slug,
          // seo_title: data?.seo_title,
          // seo_description: data?.seo_description,
          // canonical: data?.canonical,
          // follow: data?.follow,
          // index: data?.index,
        });
        setExistingBanner(data.image);
      } catch (error) {
        message.error("خطا در دریافت اطلاعات کشور.");
        navigate("/country");
      } finally {
        setLoadingBrand(false);
      }
    };

    fetchBrand();
  }, [id, form, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const formData = new FormData();

      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          formData.append(key, value);
        }
      };

      formData.append("name", values.name);
      formData.append("slug", values.slug);

      // SEO Fields (ensure empty values are sent)
      // appendIfExists("seo_title", values.seo_title);
      // appendIfExists("seo_description", values.seo_description);
      // appendIfExists("canonical", values.canonical);
      // formData.append("follow", values.follow ? "1" : "0");
      // formData.append("index", values.index ? "1" : "0");

      await api.post(`/panel/country/${id}?_method=PUT`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("کشور با موفقیت به‌روزرسانی شد.");
      navigate("/country");
    } catch (error) {
      message.error("خطا در به‌روزرسانی کشور.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <div>
        <h2 className="mb-10 text-xl">ویرایش کشور</h2>
        <Spin spinning={loading || loadingBrand}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="name"
              label="عنوان کشور"
              rules={[
                {
                  required: true,
                  message: "لطفاً عنوان را وارد کنید.",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="slug"
              label="پیوند(لینک این  کشور در وبسایت)"
              rules={[
                {
                  required: true,
                  message: "لطفاً پیوند را وارد کنید.",
                },
              ]}
            >
              <Input />
            </Form.Item>

            {/* <Divider>بخش سئو</Divider>
            <Form.Item name="seo_title" label="عنوان سئو">
              <Input />
            </Form.Item>

            <Form.Item name="seo_description" label="توضیحات سئو">
              <TextArea rows={4} />
            </Form.Item>

            <Form.Item name="canonical" label="URL Canonical">
              <Input />
            </Form.Item>

            <Row gutter={24}>
              <Col span={12}>
                <Form.Item name="follow" label="Follow" valuePropName="checked">
                  <Switch defaultChecked="true" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="index" label="Index" valuePropName="checked">
                  <Switch defaultChecked="true" />
                </Form.Item>
              </Col>
            </Row> */}

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  ذخیره تغییرات
                </Button>
                <Button
                  onClick={() => navigate("/country")}
                  style={{ marginRight: "8px" }}
                >
                  انصراف
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </Card>
  );
};

export default EditCountry;
